var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuizFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.15 31q.85 0 1.45-.6t.6-1.45q0-.85-.6-1.45t-1.45-.6q-.85 0-1.45.6t-.6 1.45q0 .85.6 1.45t1.45.6Zm-1.25-6.3h2.35q.1-1.45.425-2.15.325-.7 1.625-1.95 1.35-1.3 1.875-2.275.525-.975.525-2.275 0-2.3-1.575-3.75Q29.55 10.85 27 10.85q-1.9 0-3.4 1.025t-2.2 2.875l2.25.95q.55-1.25 1.375-1.9.825-.65 1.975-.65 1.5 0 2.425.85.925.85.925 2.15 0 1-.45 1.75t-1.6 1.6q-1.6 1.45-2 2.325-.4.875-.4 2.875ZM13 38q-1.2 0-2.1-.9-.9-.9-.9-2.1V7q0-1.2.9-2.1.9-.9 2.1-.9h28q1.2 0 2.1.9.9.9.9 2.1v28q0 1.2-.9 2.1-.9.9-2.1.9Zm-6 6q-1.2 0-2.1-.9Q4 42.2 4 41V10h3v31h31v3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizFilled);
export default __webpack_public_path__ + "static/media/quiz_filled.690b0e672f83b09ee23d46cc35fa9f3b.svg";
export { ForwardRef as ReactComponent };